/**
 * Formats a scheduled-hours value for display: trailing zeros trimmed,
 * with an "h" suffix. 3 -> "3h", 4.5 -> "4.5h", 9.25 -> "9.25h", 0 -> "0h".
 */
export function formatHours(hours: number): string {
  const rounded = Math.round(hours * 100) / 100;
  return `${rounded}h`;
}
